<template>
  <div class="content">
    <div class="container-fluid" style="height:100vh; margin:0; padding:0;">
      <div class="row" style="height:100%;">
        <div class="col-md-12" style="height:100%; padding:0;">
          <iframe
            v-if="policyUrl"
            :src="policyUrl"
            style="width:100%; height:100%; border:none;"
          ></iframe>
          <div v-else style="padding: 20px; text-align: center;">
            Company policy has not been configured yet. An admin can set it from Settings &gt; General Settings.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DEFAULT_POLICY_URL } from "src/assets/config/constants.js";

export default {
  name: "Policies",
  computed: {
    policyUrl() {
      const constants = this.$store.state.auth.constants || {};
      const url = (constants.policyUrl || DEFAULT_POLICY_URL).trim();
      // Google Docs edit/view links can't be embedded; switch them to the preview view
      return url.replace(/(docs\.google\.com\/document\/d\/[^/]+)\/(edit|view)[^#]*(#.*)?$/, "$1/preview");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Policies.vue